import { render } from "./TournamentArenaList.vue?vue&type=template&id=3889e0ec&scoped=true"
import script from "./TournamentArenaList.vue?vue&type=script&lang=js"
export * from "./TournamentArenaList.vue?vue&type=script&lang=js"

import "./TournamentArenaList.vue?vue&type=style&index=0&id=3889e0ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3889e0ec"]])

export default __exports__